import React from "react";
import { Modal } from "antd";
import { PDFViewer } from "@react-pdf/renderer";

const PDFModal = ({ visible, onClose, pdf }) => {
  return (
    <Modal
      open={visible}
      footer={null}
      width={900}
      onCancel={onClose}
      destroyOnHidden
    >
      <div style={{ height: "80vh" }}>
        <PDFViewer width="100%" height="100%">
          {pdf}
        </PDFViewer>
      </div>
    </Modal>
  );
};

export default PDFModal;